export default "__VITE_ASSET__AP5540Ji__"